import { useEffect } from 'react';

import WheelCanvas from '../WheelCanvas';
import { useWheelData } from '@lib/hooks/useWheelData';
import { wheelPreviewCheck } from '../helpers/wheelPreviewCheck';

const PreviewWheel = (props) => {
  const { opts, setOpts, setWheelState, streamId } = useWheelData(s => ({
    opts: s.opts,
    setOpts: s.setOpts,
    setWheelState: s.setWheelState,
    streamId: s.streamId,
  }));

  useEffect(() => {
    wheelPreviewCheck(opts, setOpts, setWheelState);
  }, [opts]);

  return (
    <>
      <WheelCanvas
        streamId={streamId}
        splitDiv={props.splitDiv}
        playSound={props.playSound}
        layoutMode={props.layoutMode}
        stopFeature={props.stopFeature}
        currentIndex={props.currentIndex}
        isFullScreen={props.isFullScreen}
        playResultSound={props.playResultSound}
        playButtonSound={props.playButtonSound}
        currentRosResult={props.currentRosResult}
        showInstantCustomisationPopup={props.showInstantCustomisationPopup}
      />
    </>
  );
};

export default PreviewWheel;
